// frontend/src/api/auth.js
import { apiClient } from './index';

const authApi = {
  register: async (userData) => {
    return await apiClient.post('/auth/register', userData);
  },

  login: async (credentials) => {
    return await apiClient.post('/auth/login', credentials);
  },

  socialLogin: async (idToken) => {
    return await apiClient.post('/auth/social-login', { id_token: idToken });
  },

  // --- PHONE AUTH (OTP) ---
  checkPhone: async (phone) => {
      return await apiClient.post('/auth/check-phone', { phone });
  },

  sendOtp: async (phone) => {
      return await apiClient.post('/auth/send-otp', { phone });
  },

  // fullName is sent on first phone sign-up only (not on a password reset).
  verifyOtpAndRegister: async (phone, pinId, otp, password, fullName = null) => {
      const payload = { phone, pin_id: pinId, otp, password };
      if (fullName) payload.full_name = fullName;
      return await apiClient.post('/auth/verify-otp', payload);
  },

  // --- EMAIL VERIFICATION (OTP) ---
  verifyEmailOtp: async (email, pinId, otp) => {
      return await apiClient.post('/auth/verify-email', { email, pin_id: pinId, otp });
  },
  // --------------------------

  logout: async () => {
    return await apiClient.post('/auth/logout');
  },

  getCurrentUser: async () => {
    return await apiClient.get('/auth/user');
  },

  updateUserProfile: async (profileData) => {
    return await apiClient.put('/auth/user', profileData);
  },

  deleteAccount: async () => {
    return await apiClient.delete('/auth/user');
  },

  changePassword: async (passwordData) => {
    return await apiClient.put('/auth/password', passwordData);
  },

  forgotPassword: async (emailData) => {
    return await apiClient.post('/auth/forgot-password', emailData);
  },

  resetPassword: async (resetData) => {
    return await apiClient.post('/auth/reset-password', resetData);
  },

  // Lets the reset page say straight away if a link has already expired.
  verifyResetToken: async (token) => {
    return await apiClient.post('/auth/verify-reset-token', { token });
  },
};

export { authApi };
